import React from 'react'

export function WarehouseUpdateDetails() {
    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <h5 className="secHeading">Warehouse Details</h5>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Job No. -  </td>
                                                        <td className="py-1">4535353</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> End Customer Type -  </td>
                                                        <td className="py-1">Tourist</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Shipment Status -  </td>
                                                        <td className="py-1">xyz</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Value of Goods. -  </td>
                                                        <td className="py-1">4535353</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>


                                        <div className="col-md-6 border-start">
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">Customer Name - </td>
                                                        <td className="py-1">Lorem Ipsum</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Customer Contact No. - </td>
                                                        <td className="py-1">98787963335</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Retailer Contact No. - </td>
                                                        <td className="py-1">+919898959898</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Comments - </td>
                                                        <td className="py-1">Goods</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card h-100 py-3">
                                    <h5 className="mt-0 px-3">Pick Up Details</h5>
                                    <div className="mt-3">
                                        <ul class="list-group lt_list px-0 list-group-flush">
                                            <li class="list-group-item ">
                                                <label><b>Lorem Ipsum</b></label>
                                                <label><b>Address -</b> 55 - IIM Collge road, A.B. Road, Pigdamber</label>
                                                <label><b>Contact No. -</b> +919575961109</label>
                                            </li>
                                            <li class="list-group-item ">
                                                <label><b>Lorem Ipsum</b></label>
                                                <label><b>Address -</b> 55 - IIM Collge road, A.B. Road, Pigdamber</label>
                                                <label><b>Contact No. -</b> +919575961109</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">

                                <div className="card h-100 p-3">
                                    <ul className="nav mb-3 mt-0 tablist profiletab" id="pills-tab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link active" id="pills-instructions-tab" data-bs-toggle="pill" data-bs-target="#pillsinstructions" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/document.svg" /><span className="showondesk">Warehouse Cargo Details</span></a>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link" id="pills-cargodtls-tab" data-bs-toggle="pill" data-bs-target="#pillscargodtls" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/package.svg" /><span className="showondesk"> Booking Cargo Details</span></a>
                                        </li>

                                        {/* <li className="nav-item" role="presentation">
                                            <a className="nav-link" id="pills-payment-tab" data-bs-toggle="pill" data-bs-target="#pillspayment" type="button" ><img className="showonmob" height="20" src="/admin/assets/images/invoice.svg" /><span className="showondesk">Payment Details</span></a>
                                        </li> */}

                                    </ul>

                                    <div className="tab-content " id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pillsinstructions" role="tabpanel">
                                            <h5 className="my-4 fw-bold">warehouse Cargo </h5>
                                            <div className="col-12">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr className="lh-sm text-center">

                                                                <th> Item Code</th>
                                                                <th>Item Description</th>
                                                                <th>No. of Packages</th>
                                                                <th>Weight </th>
                                                                <th>Dimension<br />( L x W x H cms)</th>
                                                                <th>Description</th>
                                                                <th>Total Volume </th>
                                                                <th>Total Weight</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td> 98343 </td>
                                                                <td>xyz </td>
                                                                <td> 98 </td>
                                                                <td> 9Kg </td>
                                                                <td> 127cm </td>
                                                                <td> lurem Goods </td>
                                                                <td> 98 </td>
                                                                <td> 98kg </td>
                                                            </tr>
                                                            <tr>
                                                                <td> 98343 </td>
                                                                <td>xyz </td>
                                                                <td> 98 </td>
                                                                <td> 9Kg </td>
                                                                <td> 127cm </td>
                                                                <td> lurem Goods </td>
                                                                <td> 98 </td>
                                                                <td> 98kg </td>
                                                            </tr>
                                                            <tr>
                                                                <td> 98343 </td>
                                                                <td>xyz </td>
                                                                <td> 98 </td>
                                                                <td> 9Kg </td>
                                                                <td> 127cm </td>
                                                                <td> lurem Goods </td>
                                                                <td> 98 </td>
                                                                <td> 98kg </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="pillscargodtls" role="tabpanel">
                                            <h5 className="my-4 fw-bold">Booking Cargo </h5>
                                            <div className="col-12">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>

                                                            <th> Item Code</th>
                                                            <th>Item Description</th>
                                                            <th>No. of Packages</th>
                                                            <th>Weight </th>
                                                            <th>Dimension<br />( L x W x H cms)</th>
                                                            <th>Description</th>
                                                            <th>Total Volume </th>
                                                            <th>Total Weight</th>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td> 98343 </td>
                                                                <td>xyz </td>
                                                                <td> 98 </td>
                                                                <td> 9Kg </td>
                                                                <td> 127cm </td>
                                                                <td> lurem Goods </td>
                                                                <td> 98 </td>
                                                                <td> 98kg </td>
                                                                {/* <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Yes</span> </td> */}
                                                            </tr>
                                                            <tr>
                                                                <td> 98343 </td>
                                                                <td>xyz </td>
                                                                <td> 98 </td>
                                                                <td> 9Kg </td>
                                                                <td> 127cm </td>
                                                                <td> lurem Goods </td>
                                                                <td> 98 </td>
                                                                <td> 98kg </td>
                                                                {/* <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Yes</span> </td> */}
                                                            </tr>
                                                            <tr>
                                                                <td> 98343 </td>
                                                                <td>xyz </td>
                                                                <td> 98 </td>
                                                                <td> 9Kg </td>
                                                                <td> 127cm </td>
                                                                <td> lurem Goods </td>
                                                                <td> 98 </td>
                                                                <td> 98kg </td>
                                                                {/* <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Yes</span> </td> */}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="tab-pane fade" id="pillspayment" role="tabpanel">
                                        <h5 className="my-4 fw-bold">Payment Details</h5>
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Invoice#</th>
                                                        <th>Date</th>
                                                        <th>Amount</th>
                                                        <th>Adj Amount</th>
                                                        <th>OS Amount</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>#6565656565</td>
                                                        <td>5 Apr, 2021</td>
                                                        <td>6565 AED</td>
                                                        <td>65 AED</td>
                                                        <td>10 AED</td>
                                                        <td><span className="badge bg-warning">Pending</span></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="card h-100 py-3">
                                    <h5 className="mt-0 px-3">Vendor Assigned</h5>
                                    <div className="mt-3">

                                        <ul class="list-group lt_list px-0 list-group-flush">
                                            <li class="list-group-item ">
                                                <label><b>Lorem Ipsum</b></label>
                                                <label><b>Pickup Date -</b> 25 Jan, 2021 </label>
                                                <label><b>Cost -</b> AED 20.00 </label>
                                                <label><b>Delivery Date -</b> 25 Jan, 2021 </label>
                                            </li>
                                            <li class="list-group-item ">
                                                <label><b>Lorem Ipsum</b></label>
                                                <label><b>Pickup Date -</b> 25 Jan, 2021 </label>
                                                <label><b>Cost -</b> AED 20.00 </label>
                                                <label><b>Delivery Date -</b> 25 Jan, 2021 </label>
                                            </li>
                                        </ul>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </div >
    )
}

